import React from 'react';
import { Shield, Award, FileCheck, Lock, TrendingUp, Zap } from 'lucide-react';

const AnimatedBackground = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {/* Floating Icons */}
      <div className="absolute top-[10%] left-[5%] text-[#E2F8FE] opacity-30 animate-float">
        <Shield className="h-16 w-16" />
      </div>
      <div className="absolute top-[20%] right-[10%] text-[#E2F8FE] opacity-25 animate-float-delayed">
        <Award className="h-20 w-20" />
      </div>
      <div className="absolute top-[60%] left-[15%] text-[#E2F8FE] opacity-20 animate-float-slow">
        <FileCheck className="h-24 w-24" />
      </div>
      <div className="absolute top-[70%] right-[20%] text-[#E2F8FE] opacity-30 animate-float">
        <Lock className="h-18 w-18" />
      </div>
      <div className="absolute top-[40%] right-[5%] text-[#E2F8FE] opacity-25 animate-float-delayed">
        <TrendingUp className="h-22 w-22" />
      </div>
      <div className="absolute top-[85%] left-[40%] text-[#E2F8FE] opacity-20 animate-float-slow">
        <Zap className="h-20 w-20" />
      </div>
      
      {/* Additional decorative circles */}
      <div className="absolute top-[15%] left-[25%] w-32 h-32 bg-[#E2F8FE] rounded-full opacity-10 blur-2xl animate-pulse-slow"></div>
      <div className="absolute top-[50%] right-[30%] w-40 h-40 bg-[#E2F8FE] rounded-full opacity-15 blur-3xl animate-float"></div>
      <div className="absolute top-[75%] left-[60%] w-36 h-36 bg-[#E2F8FE] rounded-full opacity-10 blur-2xl animate-float-delayed"></div>
    </div>
  );
};

export default AnimatedBackground;